"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OidcCallbackError = void 0;
const userErrors = new Set(["access_denied", "request_forbidden"]);
class OidcCallbackError extends Error {
  constructor(code, description) {
    super(description);
    this.code = code;
    this.description = description;
  }
  isUserError() {
    return !this.isActivationRequired() && userErrors.has(this.code);
  }
  isActivationRequired() {
    return this.code === "access_denied" && this.description.startsWith("The user is not active account.");
  }
}
exports.OidcCallbackError = OidcCallbackError;
//# sourceMappingURL=error.js.map